import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigateAwayGuardService {
  private _canNavigate = new BehaviorSubject<boolean>(true);
  canNavigate$ = this._canNavigate.asObservable();

  setCanNavigate(canNavigate: boolean) {
    this._canNavigate.next(canNavigate);
  }
}
